import styled from "@emotion/styled";
import { Navigate } from "@tanstack/react-router";
import { DEFAULT_ROUTE } from "pages/app/AccountManagementPage";
import { Flex, Text } from "styles/utility-components";

import { CreditsAndUsage } from "components/account_management/contact_credits/CreditsAndUsage";
import { SuppressionList } from "components/account_management/contact_suppressions/SuppressionList";
import { useSubscription } from "lib/hooks/subscription";
import { useUnifiedContacts } from "lib/hooks/useUnifiedContacts";

/**
 * Everything a company administers about contacts in one place: what they can
 * spend, and who they must not contact.
 *
 * Gated on the same pair as contact search, so any company with the contacts
 * experience gets both sections with no switch of its own to forget.
 */
function ContactsSettingsPage(): JSX.Element {
  const isUnifiedContactsEnabled = useUnifiedContacts();
  const { hasDataTypes } = useSubscription();

  if (!isUnifiedContactsEnabled || !hasDataTypes("CONTACTS")) {
    return <Navigate to={DEFAULT_ROUTE} replace />;
  }

  return (
    <Page>
      <Text h1>Contacts</Text>
      <CreditsAndUsage />
      <SuppressionList />
    </Page>
  );
}

export default ContactsSettingsPage;

const Page = styled(Flex)(({ theme }) => ({
  flexDirection: "column",
  gap: 40,
  padding: 24,
  overflow: "auto",
  height: "100%",
  backgroundColor: theme.colors.sysBackgroundDefault,
  width: "-webkit-fill-available",
}));
